<template>
  <section>
    <gs-header title="Cấu hình chung lương cho saller"
      :breadcrumbs="[
        {title: 'Quản lý saler', route: {name: 'saler'}}
      ]"
    >
    </gs-header>
    <div class="padding-sm-all">
      <el-form :model="localConfig" :rules="rules" label-width="200px" label-position="top" ref="config-saler-salary" @submit.prevent.native="validateBeforeSubmit()">
        <el-row :gutter="30" class="remove-margin">
          <el-col :span="24">
            <h3>Nhân viên chính thức</h3>
            <el-row :gutter="20" class="remove-margin">
              <el-col :span="18">
                <el-form-item label="KPI" prop="employee.kpi">
                  <el-row :gutter="20" class="margin-sm-bottom">
                    <el-col :span="3" class="text-center">&nbsp;</el-col>
                    <el-col :span="5" class="text-center">Số vận đơn</el-col>
                    <el-col :span="5" class="text-center">Số tiền / 1 đơn</el-col>
                    <el-col :span="5" class="text-center">Tiền thưởng</el-col>
                    <el-col :span="5" class="text-center">Thêm tháng tích lũy</el-col>
                    <el-col :span="1" class="text-center">&nbsp;</el-col>
                  </el-row>
                  <el-row class="margin-sm-bottom" :gutter="20" v-for="(kpi, index) in kpiEmployee" :key="index">
                    <el-col :span="3">{{index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'}}</el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiEmployee[index]['number']" placeholder="Số đơn" class="input-number-kpi">
                        <div slot="prepend"><span class="text-red">
                          <span v-if="parseInt(kpiEmployee[index]['number']) !== -1">
                            {{index === 0 ? '0' : kpiEmployee[index - 1]['number'] | number }} - {{ kpiEmployee[index]['number'] | number }} đơn
                          </span>
                          <span v-else>
                            > {{kpiEmployee[index - 1]['number']| number}} đơn
                          </span>
                        </span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiEmployee[index]['money']" placeholder="Số tiền / 1 đơn">
                        <div slot="append"><span class="text-red">{{kpiEmployee[index]['money'] | vnd}}</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiEmployee[index]['bonus']" placeholder="Tiền thưởng">
                        <div slot="append"><span class="text-red">{{kpiEmployee[index]['bonus'] | vnd}}</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiEmployee[index]['month_plus']" placeholder="Thêm tháng tích lũy">
                        <div slot="append"><span class="text-red">{{kpiEmployee[index]['month_plus']}} tháng</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="1">
                      <a @click.prevent="removeKpi(kpiEmployee, index)" class="text-red cursor-pointer"><i class="fa fa-trash"></i></a>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="margin-sm-bottom">
                    <el-col :span="24" class="text-center">
                      <a @click.prevent="newKpi(kpiEmployee)" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm mới</a>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="Số tiền / 1 đơn tích lũy" prop="employee.salary_accumulation">
                  <el-input v-model="localConfig.employee.salary_accumulation" placeholder="Số tiền / 1 đơn tích lũy">
                    <div slot="append"><span class="text-red">{{localConfig.employee.salary_accumulation | vnd}}</span></div>
                  </el-input>
                </el-form-item>

                <el-form-item label="Số tiền / 1 khách hàng mới" prop="employee.salary_by_customer">
                  <el-input v-model="localConfig.employee.salary_by_customer" placeholder="Số tiền / 1 khách hàng mới">
                    <div slot="append"><span class="text-red">{{localConfig.employee.salary_by_customer | vnd}}</span></div>
                  </el-input>
                </el-form-item>

                <el-form-item label="Số tháng tích lũy đơn" prop="employee.month_accumulation">
                  <el-input v-model="localConfig.employee.month_accumulation" placeholder="Số tháng tích lũy đơn">
                    <div slot="append"><span class="text-red">{{localConfig.employee.month_accumulation | number}} tháng</span></div>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <h3>Nhân viên thử việc</h3>
            <el-row :gutter="20" class="remove-margin">
              <el-col :span="18">
                <el-form-item label="KPI" prop="trainee.kpi">
                  <el-row :gutter="20" class="margin-sm-bottom">
                    <el-col :span="3" class="text-center">&nbsp;</el-col>
                    <el-col :span="5" class="text-center">Số vận đơn</el-col>
                    <el-col :span="5" class="text-center">Số tiền / 1 đơn</el-col>
                    <el-col :span="5" class="text-center">Tiền thưởng</el-col>
                    <el-col :span="5" class="text-center">Thêm tháng tích lũy</el-col>
                    <el-col :span="1" class="text-center">&nbsp;</el-col>
                  </el-row>
                  <el-row class="margin-sm-bottom" :gutter="20" v-for="(kpi, index) in kpiTrainee" :key="index">
                    <el-col :span="3">{{index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'}}</el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiTrainee[index]['number']" placeholder="Số đơn" class="input-number-kpi">
                        <div slot="prepend"><span class="text-red">
                          <span v-if="parseInt(kpiTrainee[index]['number']) !== -1">
                            {{index === 0 ? '0' : kpiTrainee[index - 1]['number'] | number }} - {{ kpiTrainee[index]['number'] | number }} đơn
                          </span>
                          <span v-else>
                            > {{kpiTrainee[index - 1]['number']| number}} đơn
                          </span>
                        </span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiTrainee[index]['money']" placeholder="Số tiền / 1 đơn">
                        <div slot="append"><span class="text-red">{{kpiTrainee[index]['money'] | vnd}}</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiTrainee[index]['bonus']" placeholder="Tiền thưởng">
                        <div slot="append"><span class="text-red">{{kpiTrainee[index]['bonus'] | vnd}}</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiTrainee[index]['month_plus']" placeholder="Thêm tháng tích lũy">
                        <div slot="append"><span class="text-red">{{kpiTrainee[index]['month_plus']}} tháng</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="1">
                      <a @click.prevent="removeKpi(kpiTrainee, index)" class="text-red cursor-pointer"><i class="fa fa-trash"></i></a>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="margin-sm-bottom">
                    <el-col :span="24" class="text-center">
                      <a @click.prevent="newKpi(kpiTrainee)" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm mới</a>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="Số tiền / 1 đơn tích lũy" prop="trainee.salary_accumulation">
                  <el-input v-model="localConfig.trainee.salary_accumulation" placeholder="Số tiền / 1 đơn tích lũy">
                    <div slot="append"><span class="text-red">{{localConfig.trainee.salary_accumulation | vnd}}</span></div>
                  </el-input>
                </el-form-item>

                <el-form-item label="Số tiền / 1 khách hàng mới" prop="trainee.salary_by_customer">
                  <el-input v-model="localConfig.trainee.salary_by_customer" placeholder="Số tiền / 1 khách hàng mới">
                    <div slot="append"><span class="text-red">{{localConfig.trainee.salary_by_customer | vnd}}</span></div>
                  </el-input>
                </el-form-item>

                <el-form-item label="Số tháng tích lũy đơn" prop="trainee.month_accumulation">
                  <el-input v-model="localConfig.trainee.month_accumulation" placeholder="Số tháng tích lũy đơn">
                    <div slot="append"><span class="text-red">{{localConfig.trainee.month_accumulation | number}} tháng</span></div>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <h3>Nhân viên parttime / CTV</h3>
            <el-row :gutter="20" class="remove-margin">
              <el-col :span="18">
                <el-form-item label="KPI" prop="parttime.kpi">
                  <el-row :gutter="20" class="margin-sm-bottom">
                    <el-col :span="3" class="text-center">&nbsp;</el-col>
                    <el-col :span="5" class="text-center">Số vận đơn</el-col>
                    <el-col :span="5" class="text-center">Số tiền / 1 đơn</el-col>
                    <el-col :span="5" class="text-center">Tiền thưởng</el-col>
                    <el-col :span="5" class="text-center">Thêm tháng tích lũy</el-col>
                    <el-col :span="1" class="text-center">&nbsp;</el-col>
                  </el-row>
                  <el-row class="margin-sm-bottom" :gutter="20" v-for="(kpi, index) in kpiPartTime" :key="index">
                    <el-col :span="3">{{index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'}}</el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiPartTime[index]['number']" placeholder="Số đơn" class="input-number-kpi">
                        <div slot="prepend"><span class="text-red">
                          <span v-if="parseInt(kpiPartTime[index]['number']) !== -1">
                            {{index === 0 ? '0' : kpiPartTime[index - 1]['number'] | number }} - {{ kpiPartTime[index]['number'] | number }} đơn
                          </span>
                          <span v-else>
                            > {{kpiPartTime[index - 1]['number']| number}} đơn
                          </span>
                        </span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiPartTime[index]['money']" placeholder="Số tiền / 1 đơn">
                        <div slot="append"><span class="text-red">{{kpiPartTime[index]['money'] | vnd}}</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiPartTime[index]['bonus']" placeholder="Tiền thưởng">
                        <div slot="append"><span class="text-red">{{kpiPartTime[index]['bonus'] | vnd}}</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiPartTime[index]['month_plus']" placeholder="Thêm tháng tích lũy">
                        <div slot="append"><span class="text-red">{{kpiPartTime[index]['month_plus']}} tháng</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="1">
                      <a @click.prevent="removeKpi(kpiPartTime, index)" class="text-red cursor-pointer"><i class="fa fa-trash"></i></a>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="margin-sm-bottom">
                    <el-col :span="24" class="text-center">
                      <a @click.prevent="newKpi(kpiPartTime)" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm mới</a>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="Số tiền / 1 đơn tích lũy" prop="parttime.salary_accumulation">
                  <el-input v-model="localConfig.parttime.salary_accumulation" placeholder="Số tiền / 1 đơn tích lũy">
                    <div slot="append"><span class="text-red">{{localConfig.parttime.salary_accumulation | vnd}}</span></div>
                  </el-input>
                </el-form-item>

                <el-form-item label="Số tiền / 1 khách hàng mới" prop="parttime.salary_by_customer">
                  <el-input v-model="localConfig.parttime.salary_by_customer" placeholder="Số tiền / 1 khách hàng mới">
                    <div slot="append"><span class="text-red">{{localConfig.parttime.salary_by_customer | vnd}}</span></div>
                  </el-input>
                </el-form-item>

                <el-form-item label="Số tháng tích lũy đơn" prop="parttime.month_accumulation">
                  <el-input v-model="localConfig.parttime.month_accumulation" placeholder="Số tháng tích lũy đơn">
                    <div slot="append"><span class="text-red">{{localConfig.parttime.month_accumulation | number}} tháng</span></div>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </section>
</template>

<script>
import { getSysConfig, changeSysConfig } from 'src/api/saller'
import { head } from 'lodash'
export default {
  name: 'SallerConfig',
  data () {
    return {
      submitting: false,
      localConfig: {
        'parttime': {
          'kpi': {},
          'bonus': {},
          'month_plus': {},
          'salary_accumulation': 0,
          'salary_by_customer': 0,
          'month_accumulation': 0
        },
        'trainee': {
          'kpi': {},
          'bonus': {},
          'month_plus': {},
          'salary_accumulation': 0,
          'salary_by_customer': 0,
          'month_accumulation': 0
        },
        'employee': {
          'kpi': {},
          'bonus': {},
          'month_plus': {},
          'salary_accumulation': 0,
          'salary_by_customer': 0,
          'month_accumulation': 0
        }
      },
      kpiPartTime: [],
      kpiTrainee: [],
      kpiEmployee: [],
      rules: {}
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.submitting = true
      this.$refs['config-saler-salary'].validate((valid) => {
        if (valid) {
          this.localConfig.parttime.kpi = {}
          this.localConfig.parttime.bonus = {}
          this.localConfig.parttime.month_plus = {}
          this.kpiPartTime.forEach(value => {
            this.localConfig.parttime.kpi[value.number] = value.money
            this.localConfig.parttime.bonus[value.number] = value.bonus
            this.localConfig.parttime.month_plus[value.number] = value.month_plus
          })
          this.localConfig.trainee.kpi = {}
          this.localConfig.trainee.bonus = {}
          this.localConfig.trainee.month_plus = {}
          this.kpiTrainee.forEach(value => {
            this.localConfig.trainee.kpi[value.number] = value.money
            this.localConfig.trainee.bonus[value.number] = value.bonus
            this.localConfig.trainee.month_plus[value.number] = value.month_plus
          })
          this.localConfig.employee.kpi = {}
          this.localConfig.employee.bonus = {}
          this.localConfig.employee.month_plus = {}
          this.kpiEmployee.forEach(value => {
            this.localConfig.employee.kpi[value.number] = value.money
            this.localConfig.employee.bonus[value.number] = value.bonus
            this.localConfig.employee.month_plus[value.number] = value.month_plus
          })
          changeSysConfig(this.localConfig).then(response => {
            switch (response.code) {
              case 200:
                this.$store.dispatch('showNotify', {
                  title: 'Lưu cấu hình thành công',
                  type: 'success'
                })
                this.submitting = false
                break
              case 422:
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.submitting = false
                break
              default:
                this.$store.dispatch('showNotify', {
                  title: 'Lưu cấu hình thất bại',
                  body: 'Hệ thống gặp sự cố vui lòng thử lại sau',
                  type: 'danger'
                })
                this.submitting = false
            }
          })
        } else {
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          this.submitting = false
          return false
        }
      })
    },
    newKpi (kpi) {
      kpi.push({
        number: -1,
        money: 0
      })
    },
    removeKpi (kpi, index) {
      kpi.splice(index, 1)
    }
  },
  mounted () {
    getSysConfig().then(response => {
      if (response.code === 200) {
        this.localConfig = response.data
        Object.keys(this.localConfig.employee.kpi).forEach(key => {
          this.kpiEmployee.push({
            number: key,
            money: this.localConfig.employee.kpi[key],
            bonus: this.localConfig.employee.bonus ? this.localConfig.employee.bonus[key] : 0,
            month_plus: this.localConfig.employee.month_plus ? this.localConfig.employee.month_plus[key] : 0
          })
        })

        Object.keys(this.localConfig.trainee.kpi).forEach(key => {
          this.kpiTrainee.push({
            number: key,
            money: this.localConfig.trainee.kpi[key],
            bonus: this.localConfig.trainee.bonus ? this.localConfig.trainee.bonus[key] : 0,
            month_plus: this.localConfig.trainee.month_plus ? this.localConfig.trainee.month_plus[key] : 0
          })
        })

        Object.keys(this.localConfig.parttime.kpi).forEach(key => {
          this.kpiPartTime.push({
            number: key,
            money: this.localConfig.parttime.kpi[key],
            bonus: this.localConfig.parttime.bonus ? this.localConfig.parttime.bonus[key] : 0,
            month_plus: this.localConfig.parttime.month_plus ? this.localConfig.parttime.month_plus[key] : 0
          })
        })
      }
    })
  }
}
</script>

<style lang="css">
.input-number-kpi input{
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// SalerConfig.vue?4d5c6b10